import styled from 'styled-components';

const ChartTooltip = styled.div`
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: 4px;
  padding: 24px;
  color: ${({ theme }) => theme.palette.common.black};
  box-shadow: 0 0 11.5px 0 rgba(230, 230, 240, 0.5);

  & p,
  & span {
    font-size: 14px;
    font-weight: 400;
  }
`;

export default ChartTooltip;
